import React, { PropTypes } from 'react';
import { Divider, Checkbox } from 'material-ui';
import MouseOverEditDiv from '../../../../tc-ui/mouse-over-edit-div';
import EditButton from '../../edit-button';
import Cell from '../../click-edit-cell';
import Miscellaneous from '../rates-table-miscellaneous.jsx';
import checkDescHelper from '../../../../../utils/checkRatesDescriptionHelper';
import R from 'ramda';

const WithRetailRate = props => {
  const {
    rates,
    onEdit,
    deleteFromProduct,
    supplierEditable,
    withEditableCell,
    updateTableCell,
    forOffer,
    rateSetName,
    rateSetCode,
    classes = {},
    ...forMiscellaneous,
    } = props;
  const exists = R.allPass([
    val => R.complement(R.isNil)(val),
    val => R.complement(R.equals(0))(val),
    val => R.complement(R.equals('0'))(val),
    val => R.complement(R.equals(''))(val),
  ]);
  const rateWithMaxAdultsPlusChild = R.call(
    R.compose(
      R.last,
      R.sort((a, b) => {
        const rateA = R.propOr(0, 'maxAdultsPlusChild', a);
        const rateB = R.propOr(0, 'maxAdultsPlusChild', b);
        if (rateA > rateB) return 1;
        if (rateB > rateA) return -1;
        return 0;
      }),
      R.filter(rate => exists(R.prop('maxAdultsPlusChild', rate)))
    ), rates);
  const maxAdultsPlusChild = R.propOr(0, 'maxAdultsPlusChild', rateWithMaxAdultsPlusChild || {});
  const hasNonStandardDesc = rates.some(rate => !rate.notApplicable && !checkDescHelper(rate.description));
  const descriptionsAllowed = rates.every(rate => rate.description && rate.description.indexOf('uest') === -1) ? '"Single", "Double", "Twin", "Triple", "Quad".' : '"1 Guest", "2 Guests", "3 Guests", "4 Guests", "5 Guests", ...etc.';
  // this is for alternating table row colors
  let rateCount = 0;
  return (<div className={classes['main']}>
    <div className="rates-table" style={{ display: 'block' }}>
      <div style={{ width: withEditableCell ? '24%' : '28%', textAlign: 'left', whiteSpace: 'pre-wrap', display: 'inline-block', fontSize: '14px' }} >
        <span className={classes.rateSetName}>{(rateSetName || '').toUpperCase()}</span>
        <span className={classes.rateSetCode}>{rateSetCode ? ` (${rateSetCode})` : ''}</span>
      </div>
      <div style={{ width: withEditableCell ? '16%' : '20%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' }}>{forOffer ? '' : 'PRICE CODE'}</div>
      <div style={{ width: withEditableCell ? '12%' : '14%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' }}>{'ADULTS'}</div>
      <div style={{ width: withEditableCell ? '16%' : '19%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' }}>{'RETAIL RATE'}</div>
      <div style={{ width: withEditableCell ? '16%' : '19%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' }}>{'NETT RATE'}</div>
      { withEditableCell ? <div style={{ width: '15%', textAlign: 'right', paddingRight: '4px', whiteSpace: 'pre', display: 'inline-block' }}>{'APPLICABLE'}</div> : undefined }
    </div>
    <Divider style={{ marginTop: '8px', display: 'block' }} />
    <MouseOverEditDiv
      regularDiv={withEditableCell || forOffer}
      editable={supplierEditable}
      doubleLineTitle
      actionButtons={
        <EditButton
          onEdit={onEdit}
          onDelete={deleteFromProduct}
          deleteButton
        />
      }
    >
      <Miscellaneous {...forMiscellaneous} rateType="includeCommission" maxAdultsPlusChild={maxAdultsPlusChild} rateSetName={rateSetName} classes={classes} />
      <div style={{ display: withEditableCell && hasNonStandardDesc ? 'block' : 'none', marginTop: '8px', marginBottom: '8px', color: '#ff4081' }}>
        <b>NOTE: Some rate types in this rate table are no longer supported, as they cannot be automated into your partners' booking systems.</b>
        <div style={{ marginTop: '8px' }}>
          Allowed Descriptions:
          <div>{descriptionsAllowed}</div>
        </div>
      </div>
      <div>
      {
        // 'rates' MUST NOT be filtered because of the classes
        rates.map((rate, key) => {
          if (!withEditableCell && rate.notApplicable) return <span key={key}/>;
          const backgroundColor = rateCount % 2 !== 0 ? 'transparent' : 'rgba(0, 0, 0, 0.1)';
          rateCount++;
          return (
            <div style={{ backgroundColor }} key={key} className={classes[`${key}-rate`] || classes[`${key}-notApplicable`]}>
              <div className="rates-table-titles">
                <Cell
                  className={classes[`${key}-description`]}
                  fullWidthInput
                  stringAllowed
                  defaultValue="-"
                  onChange={value => updateTableCell({ value, row: key, column: 'description' })}
                  editable={withEditableCell && !checkDescHelper(rate.description)}
                  style={{ color: R.call(R.cond([
                    [() => rate.notApplicable, R.always('rgba(0, 0, 0, 0.34')],
                    [() => checkDescHelper(rate.description), R.always('')],
                    [R.T, R.always('#ff4081')],
                  ])), width: withEditableCell ? '24%' : '28%', textAlign: 'left', paddingLeft: '4px', whiteSpace: 'pre', display: 'inline-block' }}
                >
                  {!checkDescHelper(rate.description) && !withEditableCell ? `${rate.description}!` : rate.description}
                </Cell>
                <Cell
                  className={classes[`${key}-priceCode`]}
                  stringAllowed
                  fullWidthInput
                  inputAlignRight
                  onChange={value => updateTableCell({ value, row: key, column: 'priceCode' })}
                  style={{ width: withEditableCell ? '16%' : '20%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' }}
                  editable={withEditableCell && !forOffer && !rate.notApplicable}
                >
                  {rate.priceCode}
                </Cell>
                <Cell
                  className={classes[`${key}-maxAdults`]}
                  decimalNumber={0}
                  inputAlignRight
                  defaultValue="-"
                  onChange={value => updateTableCell({ value, row: key, column: 'maxAdults' })}
                  style={{ width: '12%', textAlign: 'right', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', whiteSpace: 'pre', display: 'inline-block' }}
                  editable={withEditableCell && !rate.notApplicable}
                >
                  {rate.maxAdults}
                </Cell>
                <Cell
                  className={classes[`${key}-retailRate`]}
                  inputAlignRight
                  decimalNumber={2}
                  defaultValue="-"
                  onChange={value => updateTableCell({ value, row: key, column: 'retailRate' })}
                  style={{ width: withEditableCell ? '16%' : '20%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', display: 'inline-block' }}
                  editable={withEditableCell && !rate.notApplicable}
                >
                  {rate.retailRate}
                </Cell>
                <Cell
                  className={classes[`${key}-nettRate`]}
                  inputAlignRight
                  decimalNumber={2}
                  defaultValue="-"
                  onChange={value => updateTableCell({ value, row: key, column: 'nettRate' })}
                  style={{ width: withEditableCell ? '16%' : '19%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', display: 'inline-block' }}
                  editable={withEditableCell && !rate.notApplicable}
                >
                  {rate.nettRate}
                </Cell>
                {
                  withEditableCell ? <div style={{ width: '15%', display: 'inline-block !important' }}>
                    <Checkbox
                      style={{ top: '-2px', width: '50%', marginLeft: '50%' }}
                      checked={!rate.notApplicable}
                      onCheck={() => updateTableCell({ value: !rate.notApplicable, row: key, column: 'notApplicable' })}
                    />
                  </div> : undefined
                }
              </div>
            </div>
          );
        })
      }
      </div>
    </MouseOverEditDiv>
    <Divider />
  </div>);
};

WithRetailRate.propTypes = {
  _id: PropTypes.string,
  supplierEditable: PropTypes.bool,
  rates: PropTypes.array,
  rateSetName: PropTypes.string,
  minStay: PropTypes.any,
  maxStay: PropTypes.any,
  withEditableCell: PropTypes.bool,
  updateTableCell: PropTypes.func,
  onEdit: PropTypes.func,
  daysOfWeek: PropTypes.array,
  deleteRates: PropTypes.func,
  deleteFromProduct: PropTypes.func,
};

export default WithRetailRate;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/rate-tables/accommodation-rates-tables/with-retail-rate.jsx